import { RootState } from 'store/reducers';
import { useSelector } from 'react-redux';

// TODO - Replace/update when Nucleus state retired
const useFeatureFlag = (featureFlag: string): boolean => {
  const featureFlagState = useSelector((state: RootState) => state?.nucleus?.featureFlags);
  if (featureFlagState) {
    const foundFlag = Object.entries(featureFlagState).find((value) => {
      return value[0] === featureFlag;
    });
    return (!!foundFlag && !!foundFlag[1]) || false;
  }
  return false;
};

export default useFeatureFlag;
